module.exports = __webpack_public_path__ + "static/media/apartment4.24197d4e.jpg";